import { Box, styled } from "@mui/material";
import { CircleChevronDown } from "akar-icons";
import React from "react";
import { Select } from "@customer-app/components/Select";

interface IProps<V extends string | number | undefined>
  extends Omit<React.HTMLAttributes<HTMLSelectElement>, "onChange"> {
  noBorder?: boolean;
  options: { label: string; value: V }[];
  onChange: (e: V | any) => void | void;
  value?: V;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
}

// TODO: Replace primitive select with MUI select and restyle
const Selector = styled(Select)`
  border: ${props => props.theme.modernButtonBorderWidth}px solid
    ${props => props.theme.modernSecondaryButtonBorderColor} !important;
  border-radius: ${props => props.theme.modernButtonBorderRadius}px;
  font-family: ${props => props.theme.modernBodyFontFamily};
  height: 30px;
  padding: 0;
  width: 100%;
  &.smartrr-portal-select-wrapper {
    height: 30px;
    max-height: 30px;
    min-height: 30px;
  }
  & select {
    -moz-appearance: none;
    /* Removing Browser's Dropdown */
    -ms-appearance: none;
    -o-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    font-size: 14px;
    padding-left: 15px;
  }
`;

const Icon = styled(CircleChevronDown)`
  position: absolute;
  right: 10px;
  stroke: ${props => props.theme.modernIconsColor};
  top: 5.5px;
`;

export function AquariusSelect<V extends string | number | undefined>({
  noBorder,
  options,
  onChange,
  value,
  placeholder,
  isLoading,
  disabled,
  className,
  ...props
}: IProps<V>): JSX.Element {
  return (
    <Box sx={{ position: "relative" }} className={className}>
      <Selector
        test-id="selector"
        onChange={onChange}
        options={options}
        value={value}
        disabled={disabled}
        noBorder={noBorder}
        {...props}
      />

      <Icon strokeWidth={2} size={18} />
    </Box>
  );
}
